
import axios from "axios";
import { baseUrl } from "../config/clientsConfig";

const WebhooksService ={
  fetchFbPages: () => axios.get(`${baseUrl}/listAllPages`),
  updateLeadSource: (obj) => axios.post(`${baseUrl}/updateLeadSource`,obj),
  updateSubscriptionStatus: (obj) => axios.post(`${baseUrl}/subscribeFbPage`, obj)
}

 export default WebhooksService;